var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticStyle:{"border":"1px solid gray"},attrs:{"id":"can","height":"500","width":"500"}}),_vm._v("\n\ttest\n")])
}]

export { render, staticRenderFns }